import { checkNewVersionApp } from '../checkNewVersionApp';

await checkNewVersionApp();
import { isbot } from 'isbot';

export async function init() {
	if (!isbot(navigator.userAgent)) {
		const { fileName, version } = window.getServiceWorkerInfo();
		const publicPath = window.getAppEnv('publicPath');
		const swFileName =
			process.env.NODE_ENV === 'development'
				? `${publicPath}${fileName}.dev.js`
				: `${publicPath}${fileName}.js`;
		const needToRefresh = await checkNewVersionApp();
		// navigator.serviceWorker.addEventListener(
		// 	'controllerchange',
		// 	function controllerchange() {
		// 		reload('serviceWorker');
		// 	},
		// );
		await navigator.serviceWorker
			?.register(swFileName, { scope: `${publicPath}` })
			.then((reg) => {
				console.warn(
					localStorage.getItem('serviceWorkerVersion'),
					version,
				);
				if (localStorage.getItem('serviceWorkerVersion') !== version) {
					return reg.update();
				}
			})
			.catch((e) => {
				console.warn(e);
			})
			.finally(() => {
				localStorage.setItem('serviceWorkerVersion', version);
			});

		await navigator.serviceWorker?.ready;
		if (needToRefresh) {
			reload('checkNewVersionApp');
		}
	} else {
		await checkNewVersionApp();
	}
}
function reload(who: string) {
	console.info('=========================================');
	console.info('reloadPage:', who);
	console.info('=========================================');
	window.location.reload();
}
